import { useParams } from '@rocketlane/rocket-router';
import { PageType } from 'api/page-template/types';
import { useEditorExtensionsConfigForCompanyPage } from 'components/organisms/account-spaces/editor-config';
import { useAccountSpacesRouteNavigations } from 'components/organisms/account-spaces/route-navigations';
import { DocumentPage } from './document/page';
import type { NitroPagesPermissions } from 'types/nitro-pages';

interface CompanyPageDocumentProps {
  projectId?: number;
  documentId?: number;
  accountId?: number;
  isModuleFed?: boolean;
  nitroPermissions?: NitroPagesPermissions;
}

export type { NitroPagesPermissions };

export const CompanyPageDocument = ({
  projectId,
  documentId: documentIdProp,
  accountId: accountIdProp,
  isModuleFed,
  nitroPermissions: _nitroPermissions,
}: CompanyPageDocumentProps = {}) => {
  const params = useParams();
  const documentId = documentIdProp ?? Number(params.documentId);
  const accountId = accountIdProp ?? Number(params.accountId);
  const editorExtensionsConfig = useEditorExtensionsConfigForCompanyPage();
  const { navigateToSpaceDocument } = useAccountSpacesRouteNavigations(
    projectId,
    isModuleFed,
  );

  // In module federation mode, use projectId as companyId for navigation
  // Otherwise, use accountId
  const companyIdForNavigation = projectId ?? accountId;

  return (
    <DocumentPage
      documentId={documentId}
      editorExtensionsConfig={editorExtensionsConfig}
      onBack={() => {
        navigateToSpaceDocument(companyIdForNavigation, documentId);
      }}
      pageType={PageType.Company}
    />
  );
};
